import PermissionGuard from 'components/Global/PermissionGuard';
import PayPeriodComponent from 'components/Settings/PayrollSettings/PayPeriod';

export const PayPeriod = () => {
	return (
		<PermissionGuard permission="Allow_Pay_Period">
			<PayPeriodComponent />
		</PermissionGuard>
	);
};
